/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.4.0 (NJsonSchema v9.10.46.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var GridFilterLayoutViewModel = /** @class */ (function () {
    function GridFilterLayoutViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterLayoutViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.value = data["value"] !== undefined ? data["value"] : null;
            this.customer = data["customer"] !== undefined ? data["customer"] : null;
            this.layoutId = data["layoutId"] !== undefined ? data["layoutId"] : null;
        }
    };
    GridFilterLayoutViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterLayoutViewModel();
        result.init(data);
        return result;
    };
    GridFilterLayoutViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["value"] = this.value !== undefined ? this.value : null;
        data["customer"] = this.customer !== undefined ? this.customer : null;
        data["layoutId"] = this.layoutId !== undefined ? this.layoutId : null;
        return data;
    };
    return GridFilterLayoutViewModel;
}());
export { GridFilterLayoutViewModel };
var GridFilterAssetHermesViewModel = /** @class */ (function () {
    function GridFilterAssetHermesViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterAssetHermesViewModel.prototype.init = function (data) {
        if (data) {
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.serviceContractValidTo = data["serviceContractValidTo"] ? new Date(data["serviceContractValidTo"].toString()) : null;
            this.typeDescription = data["typeDescription"] !== undefined ? data["typeDescription"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.tenantHierarchyTenantChildParentName = data["tenantHierarchyTenantChildParentName"] !== undefined ? data["tenantHierarchyTenantChildParentName"] : null;
            this.tenantHierarchyTenantChildName = data["tenantHierarchyTenantChildName"] !== undefined ? data["tenantHierarchyTenantChildName"] : null;
            this.locationName = data["locationName"] !== undefined ? data["locationName"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.statusString = data["statusString"] !== undefined ? data["statusString"] : null;
            this.isPeakDevice = data["isPeakDevice"] !== undefined ? data["isPeakDevice"] : null;
            this.peakString = data["peakString"] !== undefined ? data["peakString"] : null;
            this.alternativeNumber = data["alternativeNumber"] !== undefined ? data["alternativeNumber"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.imei = data["imei"] !== undefined ? data["imei"] : null;
            this.macAddress = data["macAddress"] !== undefined ? data["macAddress"] : null;
            this.bluetoothMacAddress = data["bluetoothMacAddress"] !== undefined ? data["bluetoothMacAddress"] : null;
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.acquisitionDate = data["acquisitionDate"] ? new Date(data["acquisitionDate"].toString()) : null;
            this.rolloutDate = data["rolloutDate"] ? new Date(data["rolloutDate"].toString()) : null;
            this.wlanIp = data["wlanIp"] !== undefined ? data["wlanIp"] : null;
            this.phoneNumber = data["phoneNumber"] !== undefined ? data["phoneNumber"] : null;
            this.purchaseDate = data["purchaseDate"] ? new Date(data["purchaseDate"].toString()) : null;
            this.guaranteeDate = data["guaranteeDate"] ? new Date(data["guaranteeDate"].toString()) : null;
            this.lastConnectionDate = data["lastConnectionDate"] ? new Date(data["lastConnectionDate"].toString()) : null;
            this.leftRepairsNumber = data["leftRepairsNumber"] !== undefined ? data["leftRepairsNumber"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
        }
    };
    GridFilterAssetHermesViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterAssetHermesViewModel();
        result.init(data);
        return result;
    };
    GridFilterAssetHermesViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["serviceContractValidTo"] = this.serviceContractValidTo ? this.serviceContractValidTo.toISOString() : null;
        data["typeDescription"] = this.typeDescription !== undefined ? this.typeDescription : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["tenantHierarchyTenantChildParentName"] = this.tenantHierarchyTenantChildParentName !== undefined ? this.tenantHierarchyTenantChildParentName : null;
        data["tenantHierarchyTenantChildName"] = this.tenantHierarchyTenantChildName !== undefined ? this.tenantHierarchyTenantChildName : null;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusString"] = this.statusString !== undefined ? this.statusString : null;
        data["isPeakDevice"] = this.isPeakDevice !== undefined ? this.isPeakDevice : null;
        data["peakString"] = this.peakString !== undefined ? this.peakString : null;
        data["alternativeNumber"] = this.alternativeNumber !== undefined ? this.alternativeNumber : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["imei"] = this.imei !== undefined ? this.imei : null;
        data["macAddress"] = this.macAddress !== undefined ? this.macAddress : null;
        data["bluetoothMacAddress"] = this.bluetoothMacAddress !== undefined ? this.bluetoothMacAddress : null;
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : null;
        data["rolloutDate"] = this.rolloutDate ? this.rolloutDate.toISOString() : null;
        data["wlanIp"] = this.wlanIp !== undefined ? this.wlanIp : null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : null;
        data["guaranteeDate"] = this.guaranteeDate ? this.guaranteeDate.toISOString() : null;
        data["lastConnectionDate"] = this.lastConnectionDate ? this.lastConnectionDate.toISOString() : null;
        data["leftRepairsNumber"] = this.leftRepairsNumber !== undefined ? this.leftRepairsNumber : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        return data;
    };
    return GridFilterAssetHermesViewModel;
}());
export { GridFilterAssetHermesViewModel };
var GridFilterAssetViewModelMinden = /** @class */ (function () {
    function GridFilterAssetViewModelMinden(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterAssetViewModelMinden.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.typeDescription = data["typeDescription"] !== undefined ? data["typeDescription"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.kd = data["kd"] !== undefined ? data["kd"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.filiale = data["filiale"] !== undefined ? data["filiale"] : null;
            this.locationName = data["locationName"] !== undefined ? data["locationName"] : null;
            this.merakiId = data["merakiId"] !== undefined ? data["merakiId"] : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.rolloutDate = data["rolloutDate"] !== undefined ? data["rolloutDate"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
        }
    };
    GridFilterAssetViewModelMinden.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterAssetViewModelMinden();
        result.init(data);
        return result;
    };
    GridFilterAssetViewModelMinden.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["typeDescription"] = this.typeDescription !== undefined ? this.typeDescription : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["kd"] = this.kd !== undefined ? this.kd : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["filiale"] = this.filiale !== undefined ? this.filiale : null;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null;
        data["merakiId"] = this.merakiId !== undefined ? this.merakiId : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["rolloutDate"] = this.rolloutDate !== undefined ? this.rolloutDate : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        return data;
    };
    return GridFilterAssetViewModelMinden;
}());
export { GridFilterAssetViewModelMinden };
var GridFilterRollInViewModel = /** @class */ (function () {
    function GridFilterRollInViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterRollInViewModel.prototype.init = function (data) {
        if (data) {
            this.rollInTaskId = data["rollInTaskId"] !== undefined ? data["rollInTaskId"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.statusString = data["statusString"] !== undefined ? data["statusString"] : null;
            this.rollInReasonId = data["rollInReasonId"] !== undefined ? data["rollInReasonId"] : null;
            this.rollInReasonName = data["rollInReasonName"] !== undefined ? data["rollInReasonName"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.locationName = data["locationName"] !== undefined ? data["locationName"] : null;
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : null;
            this.lastModifiedDate = data["lastModifiedDate"] ? new Date(data["lastModifiedDate"].toString()) : null;
            this.rollInTaskAssetCount = data["rollInTaskAssetCount"] !== undefined ? data["rollInTaskAssetCount"] : null;
            this.trackingNumber = data["trackingNumber"] !== undefined ? data["trackingNumber"] : null;
        }
    };
    GridFilterRollInViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterRollInViewModel();
        result.init(data);
        return result;
    };
    GridFilterRollInViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rollInTaskId"] = this.rollInTaskId !== undefined ? this.rollInTaskId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusString"] = this.statusString !== undefined ? this.statusString : null;
        data["rollInReasonId"] = this.rollInReasonId !== undefined ? this.rollInReasonId : null;
        data["rollInReasonName"] = this.rollInReasonName !== undefined ? this.rollInReasonName : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : null;
        data["rollInTaskAssetCount"] = this.rollInTaskAssetCount !== undefined ? this.rollInTaskAssetCount : null;
        data["trackingNumber"] = this.trackingNumber !== undefined ? this.trackingNumber : null;
        return data;
    };
    return GridFilterRollInViewModel;
}());
export { GridFilterRollInViewModel };
var GridFilterAssetDefinitionViewModel = /** @class */ (function () {
    function GridFilterAssetDefinitionViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterAssetDefinitionViewModel.prototype.init = function (data) {
        if (data) {
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.typeDescription = data["typeDescription"] !== undefined ? data["typeDescription"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
        }
    };
    GridFilterAssetDefinitionViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterAssetDefinitionViewModel();
        result.init(data);
        return result;
    };
    GridFilterAssetDefinitionViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["typeDescription"] = this.typeDescription !== undefined ? this.typeDescription : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        return data;
    };
    return GridFilterAssetDefinitionViewModel;
}());
export { GridFilterAssetDefinitionViewModel };
var GridFilterAssetStatusCodeGroupViewModel = /** @class */ (function () {
    function GridFilterAssetStatusCodeGroupViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterAssetStatusCodeGroupViewModel.prototype.init = function (data) {
        if (data) {
            this.assetStatusCodeGroupId = data["assetStatusCodeGroupId"] !== undefined ? data["assetStatusCodeGroupId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
        }
    };
    GridFilterAssetStatusCodeGroupViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterAssetStatusCodeGroupViewModel();
        result.init(data);
        return result;
    };
    GridFilterAssetStatusCodeGroupViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetStatusCodeGroupId"] = this.assetStatusCodeGroupId !== undefined ? this.assetStatusCodeGroupId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data;
    };
    return GridFilterAssetStatusCodeGroupViewModel;
}());
export { GridFilterAssetStatusCodeGroupViewModel };
var GridFilterAssetStatusCodeViewModel = /** @class */ (function () {
    function GridFilterAssetStatusCodeViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterAssetStatusCodeViewModel.prototype.init = function (data) {
        if (data) {
            this.assetStatusCodeId = data["assetStatusCodeId"] !== undefined ? data["assetStatusCodeId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.translationDe = data["translationDe"] !== undefined ? data["translationDe"] : null;
            this.translationEn = data["translationEn"] !== undefined ? data["translationEn"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
        }
    };
    GridFilterAssetStatusCodeViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterAssetStatusCodeViewModel();
        result.init(data);
        return result;
    };
    GridFilterAssetStatusCodeViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetStatusCodeId"] = this.assetStatusCodeId !== undefined ? this.assetStatusCodeId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["translationDe"] = this.translationDe !== undefined ? this.translationDe : null;
        data["translationEn"] = this.translationEn !== undefined ? this.translationEn : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        return data;
    };
    return GridFilterAssetStatusCodeViewModel;
}());
export { GridFilterAssetStatusCodeViewModel };
var GridFilterAssetTypeViewModel = /** @class */ (function () {
    function GridFilterAssetTypeViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterAssetTypeViewModel.prototype.init = function (data) {
        if (data) {
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.typeDescription = data["typeDescription"] !== undefined ? data["typeDescription"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
        }
    };
    GridFilterAssetTypeViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterAssetTypeViewModel();
        result.init(data);
        return result;
    };
    GridFilterAssetTypeViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["typeDescription"] = this.typeDescription !== undefined ? this.typeDescription : null;
        data["description"] = this.description !== undefined ? this.description : null;
        return data;
    };
    return GridFilterAssetTypeViewModel;
}());
export { GridFilterAssetTypeViewModel };
var GridFilterAssetViewModel = /** @class */ (function () {
    function GridFilterAssetViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterAssetViewModel.prototype.init = function (data) {
        if (data) {
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.serviceContractValidTo = data["serviceContractValidTo"] ? new Date(data["serviceContractValidTo"].toString()) : null;
            this.typeDescription = data["typeDescription"] !== undefined ? data["typeDescription"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.tenantHierarchyTenantChildParentName = data["tenantHierarchyTenantChildParentName"] !== undefined ? data["tenantHierarchyTenantChildParentName"] : null;
            this.tenantHierarchyTenantChildName = data["tenantHierarchyTenantChildName"] !== undefined ? data["tenantHierarchyTenantChildName"] : null;
            this.locationName = data["locationName"] !== undefined ? data["locationName"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.statusString = data["statusString"] !== undefined ? data["statusString"] : null;
            this.isPeakDevice = data["isPeakDevice"] !== undefined ? data["isPeakDevice"] : null;
            this.peakString = data["peakString"] !== undefined ? data["peakString"] : null;
            this.alternativeNumber = data["alternativeNumber"] !== undefined ? data["alternativeNumber"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.imei = data["imei"] !== undefined ? data["imei"] : null;
            this.macAddress = data["macAddress"] !== undefined ? data["macAddress"] : null;
            this.bluetoothMacAddress = data["bluetoothMacAddress"] !== undefined ? data["bluetoothMacAddress"] : null;
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.acquisitionDate = data["acquisitionDate"] ? new Date(data["acquisitionDate"].toString()) : null;
            this.rolloutDate = data["rolloutDate"] ? new Date(data["rolloutDate"].toString()) : null;
            this.wlanIp = data["wlanIp"] !== undefined ? data["wlanIp"] : null;
            this.phoneNumber = data["phoneNumber"] !== undefined ? data["phoneNumber"] : null;
            this.purchaseDate = data["purchaseDate"] ? new Date(data["purchaseDate"].toString()) : null;
            this.guaranteeDate = data["guaranteeDate"] ? new Date(data["guaranteeDate"].toString()) : null;
            this.leftRepairsNumber = data["leftRepairsNumber"] !== undefined ? data["leftRepairsNumber"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
        }
    };
    GridFilterAssetViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterAssetViewModel();
        result.init(data);
        return result;
    };
    GridFilterAssetViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["serviceContractValidTo"] = this.serviceContractValidTo ? this.serviceContractValidTo.toISOString() : null;
        data["typeDescription"] = this.typeDescription !== undefined ? this.typeDescription : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["tenantHierarchyTenantChildParentName"] = this.tenantHierarchyTenantChildParentName !== undefined ? this.tenantHierarchyTenantChildParentName : null;
        data["tenantHierarchyTenantChildName"] = this.tenantHierarchyTenantChildName !== undefined ? this.tenantHierarchyTenantChildName : null;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusString"] = this.statusString !== undefined ? this.statusString : null;
        data["isPeakDevice"] = this.isPeakDevice !== undefined ? this.isPeakDevice : null;
        data["peakString"] = this.peakString !== undefined ? this.peakString : null;
        data["alternativeNumber"] = this.alternativeNumber !== undefined ? this.alternativeNumber : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["imei"] = this.imei !== undefined ? this.imei : null;
        data["macAddress"] = this.macAddress !== undefined ? this.macAddress : null;
        data["bluetoothMacAddress"] = this.bluetoothMacAddress !== undefined ? this.bluetoothMacAddress : null;
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : null;
        data["rolloutDate"] = this.rolloutDate ? this.rolloutDate.toISOString() : null;
        data["wlanIp"] = this.wlanIp !== undefined ? this.wlanIp : null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : null;
        data["guaranteeDate"] = this.guaranteeDate ? this.guaranteeDate.toISOString() : null;
        data["leftRepairsNumber"] = this.leftRepairsNumber !== undefined ? this.leftRepairsNumber : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        return data;
    };
    return GridFilterAssetViewModel;
}());
export { GridFilterAssetViewModel };
var GridFilterExchangePoolViewModel = /** @class */ (function () {
    function GridFilterExchangePoolViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterExchangePoolViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
        }
    };
    GridFilterExchangePoolViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterExchangePoolViewModel();
        result.init(data);
        return result;
    };
    GridFilterExchangePoolViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data;
    };
    return GridFilterExchangePoolViewModel;
}());
export { GridFilterExchangePoolViewModel };
var GridFilterI18nCustomerViewModel = /** @class */ (function () {
    function GridFilterI18nCustomerViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterI18nCustomerViewModel.prototype.init = function (data) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.group = data["group"] !== undefined ? data["group"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.translationDe = data["translationDe"] !== undefined ? data["translationDe"] : null;
            this.translationEn = data["translationEn"] !== undefined ? data["translationEn"] : null;
        }
    };
    GridFilterI18nCustomerViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterI18nCustomerViewModel();
        result.init(data);
        return result;
    };
    GridFilterI18nCustomerViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null;
        data["group"] = this.group !== undefined ? this.group : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["translationDe"] = this.translationDe !== undefined ? this.translationDe : null;
        data["translationEn"] = this.translationEn !== undefined ? this.translationEn : null;
        return data;
    };
    return GridFilterI18nCustomerViewModel;
}());
export { GridFilterI18nCustomerViewModel };
var GridFilterI18nViewModel = /** @class */ (function () {
    function GridFilterI18nViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterI18nViewModel.prototype.init = function (data) {
        if (data) {
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.group = data["group"] !== undefined ? data["group"] : null;
            this.translation = data["translation"] !== undefined ? data["translation"] : null;
        }
    };
    GridFilterI18nViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterI18nViewModel();
        result.init(data);
        return result;
    };
    GridFilterI18nViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null;
        data["key"] = this.key !== undefined ? this.key : null;
        data["group"] = this.group !== undefined ? this.group : null;
        data["translation"] = this.translation !== undefined ? this.translation : null;
        return data;
    };
    return GridFilterI18nViewModel;
}());
export { GridFilterI18nViewModel };
var GridFilterManufacturerViewModel = /** @class */ (function () {
    function GridFilterManufacturerViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterManufacturerViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
        }
    };
    GridFilterManufacturerViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterManufacturerViewModel();
        result.init(data);
        return result;
    };
    GridFilterManufacturerViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data;
    };
    return GridFilterManufacturerViewModel;
}());
export { GridFilterManufacturerViewModel };
var GridFilterRmaViewModel = /** @class */ (function () {
    function GridFilterRmaViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterRmaViewModel.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.alternativeNumber = data["alternativeNumber"] !== undefined ? data["alternativeNumber"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.tenantHierarchyLocationChildParentName = data["tenantHierarchyLocationChildParentName"] !== undefined ? data["tenantHierarchyLocationChildParentName"] : null;
            this.tenantHierarchyLocationChild = data["tenantHierarchyLocationChild"] !== undefined ? data["tenantHierarchyLocationChild"] : null;
            this.customerLocationChildParentName = data["customerLocationChildParentName"] !== undefined ? data["customerLocationChildParentName"] : null;
            this.customerLocationChild = data["customerLocationChild"] !== undefined ? data["customerLocationChild"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            this.assetTenantName = data["assetTenantName"] !== undefined ? data["assetTenantName"] : null;
            this.manufcaturerName = data["manufcaturerName"] !== undefined ? data["manufcaturerName"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.statusString = data["statusString"] !== undefined ? data["statusString"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.typeDescription = data["typeDescription"] !== undefined ? data["typeDescription"] : null;
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.rmaEventId = data["rmaEventId"] !== undefined ? data["rmaEventId"] : null;
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : null;
            this.lastModifiedDate = data["lastModifiedDate"] ? new Date(data["lastModifiedDate"].toString()) : null;
            this.exchangedAssetDefinitionId = data["exchangedAssetDefinitionId"] !== undefined ? data["exchangedAssetDefinitionId"] : null;
            this.trackingNumber = data["trackingNumber"] !== undefined ? data["trackingNumber"] : null;
            this.comment = data["comment"] !== undefined ? data["comment"] : null;
        }
    };
    GridFilterRmaViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterRmaViewModel();
        result.init(data);
        return result;
    };
    GridFilterRmaViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["alternativeNumber"] = this.alternativeNumber !== undefined ? this.alternativeNumber : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["tenantHierarchyLocationChildParentName"] = this.tenantHierarchyLocationChildParentName !== undefined ? this.tenantHierarchyLocationChildParentName : null;
        data["tenantHierarchyLocationChild"] = this.tenantHierarchyLocationChild !== undefined ? this.tenantHierarchyLocationChild : null;
        data["customerLocationChildParentName"] = this.customerLocationChildParentName !== undefined ? this.customerLocationChildParentName : null;
        data["customerLocationChild"] = this.customerLocationChild !== undefined ? this.customerLocationChild : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        data["assetTenantName"] = this.assetTenantName !== undefined ? this.assetTenantName : null;
        data["manufcaturerName"] = this.manufcaturerName !== undefined ? this.manufcaturerName : null;
        data["key"] = this.key !== undefined ? this.key : null;
        data["statusString"] = this.statusString !== undefined ? this.statusString : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["typeDescription"] = this.typeDescription !== undefined ? this.typeDescription : null;
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["rmaEventId"] = this.rmaEventId !== undefined ? this.rmaEventId : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : null;
        data["exchangedAssetDefinitionId"] = this.exchangedAssetDefinitionId !== undefined ? this.exchangedAssetDefinitionId : null;
        data["trackingNumber"] = this.trackingNumber !== undefined ? this.trackingNumber : null;
        data["comment"] = this.comment !== undefined ? this.comment : null;
        return data;
    };
    return GridFilterRmaViewModel;
}());
export { GridFilterRmaViewModel };
var GridFilterRoleViewModel = /** @class */ (function () {
    function GridFilterRoleViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterRoleViewModel.prototype.init = function (data) {
        if (data) {
            this.permissionName = data["permissionName"] !== undefined ? data["permissionName"] : null;
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
        }
    };
    GridFilterRoleViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterRoleViewModel();
        result.init(data);
        return result;
    };
    GridFilterRoleViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["permissionName"] = this.permissionName !== undefined ? this.permissionName : null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data;
    };
    return GridFilterRoleViewModel;
}());
export { GridFilterRoleViewModel };
var GridFilterServiceCenterViewModel = /** @class */ (function () {
    function GridFilterServiceCenterViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterServiceCenterViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
        }
    };
    GridFilterServiceCenterViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterServiceCenterViewModel();
        result.init(data);
        return result;
    };
    GridFilterServiceCenterViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data;
    };
    return GridFilterServiceCenterViewModel;
}());
export { GridFilterServiceCenterViewModel };
var GridFilterServiceContractViewModel = /** @class */ (function () {
    function GridFilterServiceContractViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterServiceContractViewModel.prototype.init = function (data) {
        if (data) {
            this.clientclientTenantName = data["clientclientTenantName"] !== undefined ? data["clientclientTenantName"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.serviceContractId = data["serviceContractId"] !== undefined ? data["serviceContractId"] : null;
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.validTo = data["validTo"] ? new Date(data["validTo"].toString()) : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.assetCount = data["assetCount"] !== undefined ? data["assetCount"] : null;
            this.repairTime = data["repairTime"] !== undefined ? data["repairTime"] : null;
        }
    };
    GridFilterServiceContractViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterServiceContractViewModel();
        result.init(data);
        return result;
    };
    GridFilterServiceContractViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientclientTenantName"] = this.clientclientTenantName !== undefined ? this.clientclientTenantName : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["serviceContractId"] = this.serviceContractId !== undefined ? this.serviceContractId : null;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["assetCount"] = this.assetCount !== undefined ? this.assetCount : null;
        data["repairTime"] = this.repairTime !== undefined ? this.repairTime : null;
        return data;
    };
    return GridFilterServiceContractViewModel;
}());
export { GridFilterServiceContractViewModel };
var GridFilterTenantAssetDefinitionViewModel = /** @class */ (function () {
    function GridFilterTenantAssetDefinitionViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterTenantAssetDefinitionViewModel.prototype.init = function (data) {
        if (data) {
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.customerName = data["customerName"] !== undefined ? data["customerName"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.typeDescription = data["typeDescription"] !== undefined ? data["typeDescription"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.tenantAssetDefinitionId = data["tenantAssetDefinitionId"] !== undefined ? data["tenantAssetDefinitionId"] : null;
        }
    };
    GridFilterTenantAssetDefinitionViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterTenantAssetDefinitionViewModel();
        result.init(data);
        return result;
    };
    GridFilterTenantAssetDefinitionViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["typeDescription"] = this.typeDescription !== undefined ? this.typeDescription : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["tenantAssetDefinitionId"] = this.tenantAssetDefinitionId !== undefined ? this.tenantAssetDefinitionId : null;
        return data;
    };
    return GridFilterTenantAssetDefinitionViewModel;
}());
export { GridFilterTenantAssetDefinitionViewModel };
var GridFilterTenantHierarchyViewModel = /** @class */ (function () {
    function GridFilterTenantHierarchyViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterTenantHierarchyViewModel.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"] !== undefined ? data["parentId"] : null;
            this.childId = data["childId"] !== undefined ? data["childId"] : null;
            this.childLevel = data["childLevel"] !== undefined ? data["childLevel"] : null;
            this.parentTenantType = data["parentTenantType"] !== undefined ? data["parentTenantType"] : null;
            this.child = data["child"] ? GridFilterTenantViewModel.fromJS(data["child"]) : null;
            this.parent = data["parent"] ? GridFilterTenantViewModel.fromJS(data["parent"]) : null;
        }
    };
    GridFilterTenantHierarchyViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterTenantHierarchyViewModel();
        result.init(data);
        return result;
    };
    GridFilterTenantHierarchyViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId !== undefined ? this.parentId : null;
        data["childId"] = this.childId !== undefined ? this.childId : null;
        data["childLevel"] = this.childLevel !== undefined ? this.childLevel : null;
        data["parentTenantType"] = this.parentTenantType !== undefined ? this.parentTenantType : null;
        data["child"] = this.child ? this.child.toJSON() : null;
        data["parent"] = this.parent ? this.parent.toJSON() : null;
        return data;
    };
    return GridFilterTenantHierarchyViewModel;
}());
export { GridFilterTenantHierarchyViewModel };
export var TenantType;
(function (TenantType) {
    TenantType[TenantType["Admin"] = 0] = "Admin";
    TenantType[TenantType["Reseller"] = 1] = "Reseller";
    TenantType[TenantType["Client"] = 2] = "Client";
    TenantType[TenantType["LocalPool"] = 3] = "LocalPool";
    TenantType[TenantType["ExchangePool"] = 4] = "ExchangePool";
    TenantType[TenantType["Depot"] = 5] = "Depot";
    TenantType[TenantType["Carrier"] = 6] = "Carrier";
    TenantType[TenantType["LocationGeneral"] = 7] = "LocationGeneral";
    TenantType[TenantType["Manufacturer"] = 8] = "Manufacturer";
    TenantType[TenantType["ServiceProvider"] = 9] = "ServiceProvider";
    TenantType[TenantType["RollIn"] = 10] = "RollIn";
    TenantType[TenantType["Group"] = 11] = "Group";
})(TenantType || (TenantType = {}));
var GridFilterTenantViewModel = /** @class */ (function () {
    function GridFilterTenantViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterTenantViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.level = data["level"] !== undefined ? data["level"] : null;
            this.hasConditionalChildren = data["hasConditionalChildren"] !== undefined ? data["hasConditionalChildren"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.companyName = data["companyName"] !== undefined ? data["companyName"] : null;
            this.companyUnit = data["companyUnit"] !== undefined ? data["companyUnit"] : null;
            this.parentTenant = data["parentTenant"] ? GridFilterTenantViewModel.fromJS(data["parentTenant"]) : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.scopeId = data["scopeId"] !== undefined ? data["scopeId"] : null;
            this.isMovable = data["isMovable"] !== undefined ? data["isMovable"] : null;
        }
    };
    GridFilterTenantViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterTenantViewModel();
        result.init(data);
        return result;
    };
    GridFilterTenantViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["level"] = this.level !== undefined ? this.level : null;
        data["hasConditionalChildren"] = this.hasConditionalChildren !== undefined ? this.hasConditionalChildren : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["companyUnit"] = this.companyUnit !== undefined ? this.companyUnit : null;
        data["parentTenant"] = this.parentTenant ? this.parentTenant.toJSON() : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["scopeId"] = this.scopeId !== undefined ? this.scopeId : null;
        data["isMovable"] = this.isMovable !== undefined ? this.isMovable : null;
        return data;
    };
    return GridFilterTenantViewModel;
}());
export { GridFilterTenantViewModel };
var GridFilterUserViewModel = /** @class */ (function () {
    function GridFilterUserViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterUserViewModel.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.phone = data["phone"] !== undefined ? data["phone"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.statusString = data["statusString"] !== undefined ? data["statusString"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : null;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null;
            if (data["tenants"] && data["tenants"].constructor === Array) {
                this.tenants = [];
                for (var _i = 0, _a = data["tenants"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tenants.push(GridFilterTenantViewModel.fromJS(item));
                }
            }
        }
    };
    GridFilterUserViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterUserViewModel();
        result.init(data);
        return result;
    };
    GridFilterUserViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusString"] = this.statusString !== undefined ? this.statusString : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null;
        if (this.tenants && this.tenants.constructor === Array) {
            data["tenants"] = [];
            for (var _i = 0, _a = this.tenants; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tenants"].push(item.toJSON());
            }
        }
        return data;
    };
    return GridFilterUserViewModel;
}());
export { GridFilterUserViewModel };
var IGridFilterEntity = /** @class */ (function () {
    function IGridFilterEntity(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IGridFilterEntity.prototype.init = function (data) {
        if (data) {
        }
    };
    IGridFilterEntity.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IGridFilterEntity' cannot be instantiated.");
    };
    IGridFilterEntity.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    return IGridFilterEntity;
}());
export { IGridFilterEntity };
